<template>
  <div class="books">
    <div v-if="vodData && vodData.length > 0"  class="movie-box-flex">
      <div class="item" v-for="(item, index) in vodData" :key="index" :vodId="item.vodId">
        <!-- <a class="img" :style="'background-image:url(' + item.vodPic + ')'"
        @click="toVodDetail(item)"></a> -->

        <a class="img">
          <img v-lazy="item.vodPic" @click="toVodDetail(item)"/>
        </a>

        <h5>{{item.vodName}}</h5>
      </div>
    </div>
    <div v-else class="h400">
      <div class="no_book">
        <p>暂时没有记录</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vod-list",
  props: {
    title: String,
    vodData: Array
  },
  data() {
    return {}
  },
  methods: {
    toVodDetail(vod) {
      this.$router.isBack = false;
      this.$router.push({
        path: '/vod/detail',
        query: {
          vodId: vod.vodId
        }
      })
    },
  },
  watch: {
    vodData(data) {
    }
  }
}
</script>

<style scoped>
.book-tag {
  bottom: 1.2rem !important;
}
.movie-box-flex{display: flex;flex-wrap: wrap;}
.movie-box-flex .item{ background: #fff; padding: 0 0 0 0; margin: 0.2rem 2%; width: 46%;box-sizing: content-box; border-radius: 5px;}

.item a {
  background: #1a1a1a url(../../assets/img/loading_ho2.jpg) center center no-repeat; background-size:40px;
  position: relative;
  display: block;
  /* padding-top: 68%; */
  height: 6rem;
  border-radius: 4px;
  overflow: hidden;}
.item a img{ width: 100%; height: 100%; vertical-align: middle; }
.item h5{
  color: #333;
  font-size: .5rem;
  height: 1.3rem;
  line-height: .72rem;
  overflow: hidden;
  padding:.2rem;}

</style>



// WEBPACK FOOTER //
// src/components/share/vod-list.vue